export default {

  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },

    federatedLoginError: {
      heading: 'Godkendelse mislykkedes',
      content: 'Vi kunne ikke logge dig ind. Prøv venligst igen senere, og hvis problemet fortsætter, kan du kontakte vores kundesupport.',
    },

    accountMenu: {
      myAccount: 'Min konto',
      billing: 'Fakturering',
      userManagement: 'Brugeradministration',
      organisationProfile: 'Organisationsindstillinger',
      statistics: 'Statistics',
      videos: 'Videobibliotek',
    },

    adminNavigationBar: {
      backToMainMenu: 'Tilbage til hovedmenuen',
      dashboard: 'Hovedvisning',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Ingen handlinger',
      show: 'Vis indhold',
      hide: 'Skjul indhold',
      action: {
        comment: 'kommenteret ansøgning',
        invite: 'inviteret til jobsamtale',
        reInvite: 'invitationen er sendt til kandidaten igen',
        smsInvite: 'inviteret til jobsamtale via SMS',
        smsReInvite: 'send invitation til kandidat via SMS igen',
        videoResponse: 'Kandidat har besvaret videojobsamtale',
        message: 'har afsendt e-mail',
        personalInterviewMessage: 'sendte invitation til planlagt møde',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'har afsendt videomeddelelse',
        applicationCreatedByAdmin: 'tilføjede denne kandidat',
        stageChanged: placeholderKeys => `flyttede kandidat til niveau ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Kandidaten har færdiggjort interview ${placeholder.opening}`,
        applicationCreated: 'Ansøgning oprettet',
        applicationUpdated: 'Ansøgning opdateret',
        candidateUpdated: 'Kandidat opdateret',
        introductionToOne: placeholders => `Kandidaten blev præsenteret for ${placeholders.introducee}`,
        introductionToMany: placeholders => `Kandidaten blev præsenteret for ${placeholders.introduceeCount} modtagere`,
        calendarEventCreated: placeholders => `Kandidat bekræftede møde: ${placeholders.eventStartTime}`,
        addRating: 'tilføjede vurdering',
        deleteRating: 'slettede sin vurdering',
        withdrew: 'Kandidaten trak sig fra processen.',
        resetQuestionResponse: 'slettede kandidatens svar.',
      },
      videoLink: {
        linkText: 'Vis indhold',
      },
    },

    additionalFormFields: {
      done: 'Udført',
      cancel: 'Annuller',
      edit: 'Rediger',
      delete: 'Slet',
      required: 'Påkrævet',
      optional: 'Valgfri',
      notAsked: 'Ikke spurgt',
      title: 'Yderligere formularfelter',
      add: 'Tilføj et nyt formularfelt',
      description: context => (context === 'interview'
        ? 'Yderligere felter kan ikke slettes, efter invitationer er sendt.'
        : 'Yderligere felter kan ikke slettes, hvis der er ansøgninger til stillingen.'),
      addOption: 'Tilføj',
      shortText: 'Kort tekst',
      longText: 'Lang tekst',
      singleSelect: 'Enkelt udvælgelse',
      multiSelect: 'Fælles udvælgelse',
      fieldLabelPlaceholder: 'Fagområde for kandidater',
      fieldNamePlaceholder: 'Feltnavn til rekrutteringsmedarbejdere',
      addLabel: 'Tilføj mærkat',
      addName: 'Tilføj navn',
      nameLabel: 'Fagområde',
      typeLabel: 'Fagområde-type',
      optionLabel: 'Fagområde-muligheder',
      settingsLabel: 'Formularindstillinger',
      reorder: 'Reorganisér fagområder',
      stopReordering: 'Stop reorganisering af fagområder',
      optionPlaceholder: 'Tilføj en mulighed',
      optionError: 'Valgmuligheden findes allerede',
    },

    addPublicQuestions: {
      title: 'Videospørgsmål',
      description: 'Tilføj spørgsmål til ansøgningsfase her.',
    },

    addQuestions: {
      edit: {
        start: 'Omarranger spørgsmål',
        stop: 'Stop omarrangering af spørgsmål',
      },
      placeholder: isMobile => (isMobile ? 'Klik for at upload eller optage et spørgsmål' : 'Klik for at optage et spørgsmål'),
      textQuestionPlaceholder: 'Klik for at skrive et spørgsmål',
      videoPlaceholder: isMobile => (isMobile ? 'Tilføj en ny video' : 'Tilføj en ny video'),
      library: 'Vælg fra bibliotek',
      text: 'Tekstspørgsmål',
      record: 'Optag',
      upload: 'Upload',
      answerable: 'Spørgsmål kan besvares',
      takeLimitLabel: 'Antal optagelser',
      answerTimeLabel: 'Svartid',
      preparationTimeLabel: 'Forberedelsestid',
      questionPlaceholder: 'Skriv dit spørgsmål her',
      cancel: 'Annuller',
      add: 'Tilføj',
      unlimitedLabel: 'Ubegrænset',
    },

    addVideo: {
      title: 'Arbejdsgivervideo',
      description: 'Promover din virksomhedskultur, og styrk arbejdsgiverbranding ved at føje en arbejdsgivervideo til jobannoncen',
    },

    adminCoverPhoto: {
      welcome: name => `Velkommen, ${name}!`,
      photo: 'Tilføj baggrundsbillede',
      removePhoto: 'Fjern baggrundsbillede',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Konfiguration af ansøgningsformular',
      notAsked: 'Ikke spurgt',
      optional: 'Valgfri',
      required: 'Påkrævet',
      name: 'Navn',
      coverLetter: 'Følgeskrivelse',
      email: 'E-mail',
      phoneNumber: 'Telefonnummer',
      city: 'By',
      attachments: 'Vedhæftede filer',
      links: 'Link',
      questions: 'Videospørgsmål',
      attachmentsDescription: 'Beskrivelse af vedhæftede filer',
    },

    billingPlanSelector: {
      select: 'Vælg',
      removeSelection: 'Remove selection',
      month: '/måned',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Video Interview',
      'single-recruitment': 'Enkelt rekruttering',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright specialtilpasset plan',
      plans: {
        'recright-easy': {
          info: '10 - 20 stillinger om året for små og mellemstore virksomheder for at spare tid på rekruttering.',
          info2: '',
          features: [
            'Over 50 stillinger om året',
            'Ubegrænset antal brugerpladser',
            'Brugeradministration',
            'Gratis optaget videotræning',
            'Branding',
            'Kundesupport',
          ],
          unitType: '/måned',
        },
        'recright-pro2': {
          info: '30 - 50 stillinger om året for større virksomheder med yderligere branding- og administrationsbehov.',
          info2: '',
          features: [
            'Alt i Easy plus:',
            'Rapportering',
            'Bedste praksis-træning',
            'Kundesucces',
          ],
          unitType: '/måned',
        },
        'recright-ats': {
          features: [
            'Rekrutteringsredskab',
            'Ubegrænsede stillingsannoncer',
            'Brandingvideo for arbejdsgivere',
            'Videospørgsmål i ansøgning',
            'Kandidatudvælgelse',
            'Kandidatkommunikation',
            'Team-engagement',
            'Kandidatdatabase',
          ],
          unitType: '/måned',
        },
        'recright-video-interview': {
          features: [
            'Recright ATS følger med',
            'Optagede videointerview',
            'Flere videospørgsmål',
            'Rapporteringsredskab',
            'Online kursus',
            '15 videointerviewstillinger om året',
          ],
          unitType: '/måned',
        },
        'recright-custom': {
          features: [
            'Mængdebaserede priser',
            'Dedikeret kundechef',
            'Integration med din ATS',
            'Live videointerview',
          ],
          unitType: '/måned',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/måned',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/måned',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/måned',
        },
        'single-recruitment': {
          info: 'Perfekt til at afprøve, hvor effektive forudindspillede interviews er.',
          features: [
            'Med alle funktioner',
            'Med en enkelt stillingsannonce og et videointerview',
            'gyldig i 60 dage \n\n efter stillingsannoncen og videointerviewet er oprettet',
          ],
          unitType: '/rekruttering',
        },
      },
    },

    branding: {
      headerFont: 'Skrifttype for overskrift',
      bodyFont: 'Skrifttype i brødtekst',
      backgroundColor: 'Baggrundsfarve',
      textColor: 'Tekstfarve',
      brandColor: 'Brand-farve',
      buttonTextColor: 'Farve på knaptekst',
      headerTextColor: 'Farve på overskrifttekst',
    },

    cancelSubscription: {
      cancelSubscription: 'Annuller abonnement',
      confirmMessage: 'Annuller dit abonnement',
      confirmContent: 'Er du sikker på, at du vil annullere dit abonnement? Du kan ikke oprette nye stillinger eller videointerview efter annullering. Eksisterende stillinger og videointerview forbliver åbne for kandidater i 90 dage, og du kan gennemse deres ansøgninger og videoer i al evighed. De er dine, også efter du har annulleret dit abonnement.',
    },

    candidateCard: {
      noStatus: 'Ingen status angivet',
      lastSeen: time => `Sidst set ${time}.`,
      notVisited: 'Har ikke besøgt på interview',
    },

    chooseLicenseLink: {
      title: 'Choose license',
    },

    comments: {
      placeholder: 'Tilføj en ny kommentar',
      submit: 'Tilføj',
      delete: 'Slet',
      showComments: 'Vis andres kommentarer',
      hideComments: 'Skjul andres kommentarer',
    },

    competencyList: {
      duplicateError: 'Der findes allerede en kompetence med det navn',
      defaultText: 'Hvis du er i tvivl om, hvilke kompetencer du vil bruge, har vi defineret nogle gode standardværdier til at begynde med.',
      defaultLinkText: 'Hent standardværdierne',
      addCompetency: 'Tilføj en ny kompetence',
    },

    creditCardFields: {
      cardholderName: 'Kortindehavers navn',
      creditCard: 'Kreditkortnummer',
      cvv: 'CVV',
      cvvHelp: 'CVV-koden er et trecifret nummer på bagsiden af kreditkortet.',
      expirationDate: 'Udløbsdato',
      invalidValue: 'Feltværdi er ugyldig',
    },

    currentFilters: {
      currentFilters: 'Aktuelle filtre:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `Inkl. livstidsrabat ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Inkl. rabat ${amount} EUR for ${cycles} måneder`,
    },

    discountField: {
      link: 'Jeg har en rabatkode',
      label: 'Rabatkode',
      invalidValue: 'Rabatkode er ugyldig',
    },

    emailForm: {
      emailLabel: 'Email',
      defaultButtonText: 'Send',
    },

    filterToggler: {
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
    },

    hashtags: {
      placeholder: 'Tilføj et tag',
      delete: 'Slet',
    },

    imageInput: {
      errors: {
        format: 'Filen er ikke et billede.',
        size: 'Billedet er for stort. Maks. størrelse for filen er 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Emne',
      messagePlaceholder: 'Meddelelse',
      namePlaceholder: 'Navn',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Navn på skabelon',
      titleDisclaimer:
        '[INTERVIEW TITLE] bliver erstattet med jobsamtalens titel, når invitationerne sendes ud.',
      titleDisclaimerJob: '[JOB TITLE] bliver erstattet med jobtitlen.',
      confirmLanguageChange:
        'Er du sikker på, at du vil skifte sprog? Du mister alle ændringer, der ikke er gemt.',
      formatInfo:
        'Du kan tilføje fed tekst, kursiv tekst eller links med særlig formatering:',
      cursive: '_Kursiv_',
      bolded: '*Fed*',
      link: '[http://example.com|Linktekst]',
    },

    interviewFormSetup: {
      title: 'Konfiguration af formular til jobsamtale',
      notAsked: 'Ikke spurgt',
      optional: 'Valgfri',
      required: 'Påkrævet',
      name: 'Navn',
      email: 'E-mail',
      phoneNumber: 'Telefonnummer',
      city: 'By',
      attachments: 'Vedhæftede filer',
      links: 'Link',
      attachmentsDescription: 'Beskrivelse af vedhæftede filer',
    },

    interviewRow: {
      invites: 'Invitationer',
      responses: 'Svar',
      endTime: 'Åben indtil',
      createdAt: 'Oprettelsesdato',
      timedTitle: 'Videojobsamtale på tid',
      newVideos: 'Nye svar',
    },

    introduction: {
      batchIntroduction: count => `Præsenteret for ${count} modtagere`,
    },

    jobAdRow: {
      newApplications: 'Ulæste ansøgninger',
      applications: 'Ansøgninger',
      publishTime: 'Udgivelsesdato',
      endTime: 'Åben indtil',
    },

    positionStatus: {
      open: date => (date ? `indtil ${date}` : ''),
      hidden: date => (date ? `indtil ${date}` : ''),
      filled: () => 'status: Udfyldt',
      cancelled: () => 'status: Annulleret',
      closed: () => 'status: Lukket',
      draft: () => 'Lukket (kladde)',
      unpublished: () => 'status: Ikke publiceret',
      publishTime: 'Udgivelsesdato',
    },

    jobAdTeaser: {
      add: 'Opret ny ansøgning',
      noApplications: 'Endnu ingen ansøgninger.',
      preview: 'Vis eksempel på jobannoncen her',
      placeholder: {
        first: 'Du kan booste og markedsføre din jobannonce med direkte link til din jobportal',
        second: 'alternativt kan du markedsføre netop dette job med direkte link',
        third: 'Glem heller ikke, at alle disse kun er et klik med en knap væk i titelbjælken ovenfor.',
      },
    },

    list: {
      total: count => `Total: ${count}`,
      selectAll: 'Vælg alle',
      resetSelection: count => (count > 0 ? `Nulstil valg (${count})` : 'Nulstil valg '),
    },

    liveRow: {
      finished: 'Færdig',
      coming: 'Kommende',
      active: 'Igangværende',
      titleFallback: 'Live interview',
      startTime: 'Start time',
      interviewers: 'Interviewers',
      candidates: 'Candidates',
      status: 'Status',
    },

    loginForm: {
      email: 'E-mail',
      password: 'Adgangskode',
      submit: 'Log på tjenesten',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Indtast din e-mail-adresse.',
          isEmail: value => (value ? `${value} er ikke en gyldig e-mail.` : ''),
        },
        password: {
          isRequired: 'Indtast en adgangskode.',
        },
        login: {
          incorrect: 'Logon mislykkedes.',
          deactivated:
            'Brugerkontoen er blevet deaktiveret. Kontakt din organisations administrator hos Recright.',
          tries: 'Med henblik på at værne om din sikkerhed er antallet af forsøg til adgangskodeindtastning begrænset. Prøv igen om et øjeblik, eller nulstil din adgangskode.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisationslogo her',
      removeLogo: 'Fjern logo',
      addLogo: 'Vælg logo',
    },

    modalAccountType: {
      title: 'Skift kontotype?',
      confirm: 'Skift',
      cancel: 'Annuller',
    },

    modalApplicationAllInvited: {
      title: 'Inviter kandidater',
      description: 'Alle de valgte kandidater er allerede inviteret til samtale.',
    },

    modalApplicationIntroduce: {
      title: 'Introducer kandidater',
      description: 'Indtast introduktionsmodtagerens e-mail-adresse nedenfor',
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Meddelelsesindhold',
      emailsPlaceholder: 'Modtagers e-mail-adresser',
      namePlaceholder: 'Navn',
      cancel: 'Annuller',
      sendIntroductions: 'Send introduktioner',
    },

    modalApplicationInvite: {
      title: 'Valg af en videojobsamtale',
      description: 'Vil du oprette en ny videojobsamtale eller benytte en eksisterende?',
      createNew: 'Opret ny jobsamtale',
      videoInterviewDescription: 'Inviter en ansøger til en videojobsamtale, og mød personen bag CV\'et!',
      error: {
        selectInterview: 'Vælg venligst interview.',
      },
      cancel: 'Annuller',
      close: 'Luk',
      continue: 'Fortsæt',
    },

    modalApplicationReInvite: {
      title: 'Send invitation til ansøger igen',
      description: 'Vælg det interview, du ønsker at geninvitere ansøgeren til.',
      info: 'Du kan ikke sende invitationer til interviews, der er lukkede.',
      submit: 'Gensend invitation',
      cancel: 'Annuller',
    },

    modalApplicationMessage: {
      title: 'Send meddelelse til udvalgte kandidater',
      description: 'Hvilken type meddelelse vil du sende?',
      email: 'Send e-mail',
      videoMessage: 'Send videomeddelelse',
      close: 'Luk',
      cancel: 'Annuller',
      continue: 'Fortsæt',
      sendEmail: 'Send meddelelse',
      emailTitle: 'Send e-mail til kandidater',
      emailDescription: 'Skriv e-mail til udvalgte kandidater',
      videoTitle: 'Tilføj ny video',
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Skriv din meddelelse her',
      candidates: 'kandidater',
      selectedCandidates: 'Modtagere',
      emailSent: 'E-mail afsendt!',
      answerable: 'Video kan besvares',
      signature: 'Med venlig hilsen,',
    },

    modalAskEmail: {
      title: 'Anmod om tilbud',
      description: 'Vi vil gerne høre fra dig! Angiv din e-mailadresse, så kontakter vores salgsafdeling dig snart!',
      email: 'Din e-mailadresse',
      submit: 'Send anmodning',
      cancel: 'Annuller',
      invalidValue: 'Ugyldig e-mailadresse.',
    },

    modalAtsTeaser: {
      title: 'Udgiv ledige stillinger og administrér rekrutteringsprocessen',
      content: 'Vælg de oplysninger, som du vil spørge kandidaten om, og udgiv din ledige stilling. Vi hoster din karriereside, og du kan nemt dele linket allevegne. Dit arbejdsgiverbillede forbedres med effektiv kandidatkommunikation.',
      cancel: 'Annuller',
      confirm: 'Ja, kontakt mig',
      greetings: 'Besked blev afsendt.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Vil du gerne se, hvordan dine ansøgere vurderede ansættelsesprocessen?',
      content: 'Efter hver ansættelsesproces har ansøgere mulighed for at vurdere deres oplevelse. Din overordnede vurdering er baseret på et gennemsnit af den indsamlede feedback.',
      cancel: 'Annuller',
      confirm: 'Ja, kontakt mig',
      greetings: 'Meddelelsen blev sendt.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Send meddelelse til udvalgte kandidater' : 'Send besked til kandidaten'),
      description: 'Hvilken type meddelelse vil du sende?',
      recipients: count => `Meddelelse bliver sendt til ${count} modtagere`,
      email: 'Send e-mail',
      videoMessage: 'Send videomeddelelse',
      library: 'Vælg fra bibliotek',
      close: 'Luk',
      cancel: 'Annuller',
      continue: 'Fortsæt',
      sendEmail: 'Send meddelelse',
      resendInvitation: 'Gensend invitation',
      resendInvitationSms: 'Send invitation igen via SMS',
      sms: 'Send SMS-besked',
      emailTitle: count => (count > 1 ? 'Send e-mail til kandidater' : 'Send e-mail til kandidaten'),
      emailDescription: 'Skriv e-mail til udvalgte kandidater',
      videoTitle: 'Tilføj ny video',
      libraryTitle: count => (count > 1 ? 'Send video til kandidater' : 'Send video til kandidaten'),
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Skriv din meddelelse her',
      candidates: 'kandidater',
      selectedCandidates: 'Modtagere',
      emailSent: candidates => `${candidates} e-mails afsendt!`,
      answerable: 'Video kan besvares',
      successMessage: candidates => `${candidates} videoer afsendt!`,
      scheduledInterview: 'Send invitation til planlagt møde',
      reScheduledInterview: 'Flyt møde',
      scheduledInterviewDescription: 'Lad ansøgeren planlægge et møde med dig på baggrund af din angivelse af, hvornår du er ledig.',
      reScheduledInterviewDescription: 'Ryk et møde med en ansøger. Bemærk: Tidligere mødeinvitationer annulleres',
      record: 'Optag',
      upload: 'Upload',
      required: '* Felterne mærket med en stjerne er obligatoriske.',
      tooManyRecipients: count => `Der er valgt for mange modtagere. Maksimum er ${count}.`,
      tooLongMessage:
        'Meddelelsen er for lang. Kontroller antallet af tegn. Bemærk: Visse specialtegn reducerer meddelelsens maksimale længde.',
    },

    modalEditIntroduceBatches: {
      title: 'Introduktioner',
      description: 'Her kan du administrere din stillings introduktioner. Du kan forlænge udløbstiden for introduktionslink til dine introduktionsmodtagere, fjerne modtagere fra introduktionsgruppen eller fjerne hele introduktionsgrupper fra stillingen.',
      noBatches: 'Ingen introduktioner.',
      descriptionWithCount: (candidatesCount, candidateNames) => `Introducerede ${candidateNames} og ${candidatesCount} andre til følgende modtagere:`,
      descriptionWithoutCount: candidateNames => `Introducerede ${candidateNames} til følgende modtagere:`,
      expires: 'Udløber',
      visited: 'Besøgt',
      actions: 'Handlinger',
      email: 'Email',
      close: 'Luk',
      extendLinkText: 'Forlæng',
      extendTo: date => `Forlæng til ${date}`,
      deleteBatch: 'Slet introduktionsgruppe',
      deleteBatchWarning: 'Er du sikker på, at du vil slette introduktionsgruppen?',
      maxExpirationDate: 'Udløbsdatoen kan maksimalt være 10 dage fra i dag.',
      extendedMessage: newExpirationDate => `Udløbsdatoen for modtagerens præsentationslink blev forlænget til ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Uppgift om inbjudans avsändare',
      customReplyToSubtitle:
        'Her kan du redigere afsendernavnet og svaradressen til samtaleinvitationerne. Hvis feltet efterlades tomt, bruges navnet og e-mailadressen på den bruger, der sender.',
      customReplyToEmail: 'E-mailadresse til at besvare samtaleinvitationer',
      customReplyToName: 'Afsendernavn til samtaleinvitationer',
      saveSuccess: 'Indstillingerne blev gemt!',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Gem som denne jobsamtales invitationsmeddelelse',
      title: 'Rediger jobsamtalens invitationsmeddelelse',
      info: 'Vælg det interview, du ønsker at redigere',
      close: 'Luk',
      templateOptionsLabel: 'Select template',
      templateSaved: 'Beskeden er nu blevet gemt som skabelon for dette interview.',
    },

    modalEditStages: {
      title: 'Rediger rekrutteringstrin',
      info: 'Du kan redigere, tilføje, slette og flytte rundt på brugerdefinerede trin. Bemærk, at det ikke er muligt at fjerne et trin, hvis der er kandidater på det trin.',
      addNewStage: 'Tilføj et nyt brugerdefineret trin',
      removeDisabled: 'Det er ikke muligt at slette et trin, der rummer kandidater.',
      error: 'Trinnet eksisterer i forvejen.',
      done: 'Udført',
      save: 'Gem',
      close: 'Luk',
      delete: 'Slet',
      cancel: 'Annullering',
      confirm: 'Bekræfte',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Skjulte stillinger',
      modalDescription: name => `Kontrollér, hvilke stillinger brugeren ${name} kan se.`,
      hiddenFrom: name => `Stillinger, der er skjult fra brugeren ${name}`,
      noResults: 'Ingen resultater',
      jobAdLabel: 'Jobannonce',
      interviewLabel: 'Videointerview',
      noPositions: 'Ingen stillinger',
      remove: 'Fjern',
      close: 'Luk',
      hide: 'Skjul',
      searchInfo: 'Find stillinger at skjule',
      searchPlaceholder: 'Søg efter stillingsbetegnelse eller sted',
      total: total => `${total} stillinger i alt`,
      labels: {
        title: 'Titel',
        location: 'Sted',
        time: 'Oprettelsesdato',
        actions: 'Handlinger',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Fjernelse af en bruger fra denne organisation',
      modalDescription: name =>
        `Brugeren ${name} er en ekstern bruger og vil kun blive fjernet fra denne organisation. Brugeren vil fortsat have adgang til andre organisationer i RecRight, også selvom vedkommende er fjernet her.`,
      modalExplanation: name =>
        `Derfor vil brugeren ikke længere have adgang til stillinger i denne organisation. Du vil arve adgang til stillinger, som ${name} var den eneste, der rekrutterede til.`,
      adminInRecruitmentTeam: name =>
        `Stillinger, hvor brugeren ${name} var en del af rekrutteringsteamet:`,
      noResults: 'Ingen resultater',
      noPositions: 'Ingen stillinger',
      jobAdLabel: 'Jobannonce',
      interviewLabel: 'Videointerview',
      total: total => `${total} stillinger i alt`,
      close: 'Luk',
      remove: 'Fjern fra organisationen',
      removeUserConfirmMessage: 'Fjern bruger',
      removeUserConfirmContent:
        'Er du sikker på, at du vil fjerne brugeren fra denne organisation?',
      labels: {
        title: 'Titel',
        time: 'Oprettelsesdato',
        creator: 'Ny ejer af stillingen',
      },
      otherAdmin: 'Anden administrator i rekrutteringsteamet',
    },

    modalPersonStage: {
      new: 'Ny',
      hired: 'Ansat',
      proceed: 'Fortsæt',
      personalinterview: 'Personlig jobsamtale',
      withdrawn: 'Meldt ud',
      scheduledinterview: 'Planlagt jobsamtale',
      rejected: 'Afvist',
      videointerviewed: 'Videojobsamtale',
      change: 'Flyt kandidat(erne) til næste niveau',
      info: 'Flyt den/de valgte kandidat(er) til et andet niveau. Denne information er ikke synlig for kandidaterne.',
      done: 'Flyt',
      cancel: 'Annuller',
      changed: 'Storartet!',
      changedInfo: stage => `Nu har du flyttet disse kandidater til niveauet "${stage}", så giv dem besked om det. Send dem en e-mail eller en videobesked.`,
      close: 'Luk',
      changeSingle: 'Flyt kandidaten til en anden fase',
      infoSingle: 'Flyt kandidaten til en anden fase. Denne information er ikke synlig for kandidaten.',
      changedInfoSingle: stage => `Nu, hvor du har flyttet kandidaten til fasen "${stage}", kan du fortælle det til vedkommende! \n\n Send en e-mail eller videobesked.`,
      reopenProcessConfirmPlural: 'Er du sikker på, at du ønsker at flytte disse kandidater væk fra trinnet "Meldt ud" og tilbage til rekrutteringsprocessen? Når du har bekræftet, vil kandidaterne igen kunne fuldføre jobsamtaler, som de endnu ikke har færdiggjort.',
      withdrawConfirmPlural: 'Er du sikker på, at du ønsker af melde disse kandidater ud af rekrutteringsprocessen? Hvis de meldes ud, kan kandidaterne ikke længere fuldføre jobsamtaler, som de er inviteret til.',
    },

    modalInterviewAdd: {
      timedTitle: 'Videojobsamtale på tid',
      timedDescription: 'Ansøgere optager deres svar på spørgsmål i jobsamtalen inden for en begrænset tidsramme. Du kan indstille tiden for både svar og forberedelse for hvert spørgsmål.',
      title: 'Opret ny jobsamtale',
      description: 'Vælg den type jobsamtale, du ønsker at oprette',
      friendlyTitle: 'Videosamtale',
      friendlyDescription: 'Kandidater kan lave så mange optagelser, som de ønsker, og der er ingen tidsbegrænsning for hver optagelse.',
      cancel: 'Annuller',
      continue: 'Fortsæt',
    },

    modalLiveInterviewAdd: {
      title: 'Create new live interview',
      description: 'Choose the type of live interview you want to create.',
      basicTitle: 'Live interview',
      basicDescription: 'The time of the live interview is chosen by you.',
      scheduledTitle: 'Schedule live interview',
      scheduledDescription:
        'The time of the live interview is chosen by the candidate based on your availability.',
      cancel: 'Annuller',
      continue: 'Fortsæt',
    },

    modalInterviewPublish: {
      modalTitle: 'Offentliggør indstillinger',
      publicTitle: 'Offentliggør jobsamtale',
      publicDescription: 'Denne jobsamtale har en offentlig side med en adresse, hvor du kan dele dine jobannoncer og din virksomheds hjemmeside. Alle, der er interesserede i stillingen, kan se dine spørgsmål og derefter beslutte sig for at deltage eller ej. Du modtager den sædvanlige underretning, når svarene begynder at komme ind.',
      publishButton: 'Opret offentligt link',
      unPublishButton: 'Fjern offentligt link',
      title: 'Indlejret jobsamtale',
      description: 'Interviews med et enkelt spørgsmål kan problemfrit indlejres på selskabets hjemmeside. Kandidaten indtaster sin e-mailadresse, optager et videosvar og giver link til deres LinkedIn-profil som supplerende oplysning (frivilligt).',
      descriptionMultiple:
        'Integrer let et videointerview i din jobannonce eller på virksomhedens hjemmeside. Kandidaterne skal blot indtaste deres e-mailadresse og optage videosvar, og de kan inkludere et link til deres LinkedIn-profil for at give yderligere oplysninger.',
      embedNotification: 'Man kan ikke bede om andre oplysninger med et indlejret spørgsmål.',
      embedButton: 'Opret indlejringskode',
      unEmbedButton: 'Fjern indlejring',
      close: 'Luk',
      oneError: 'En integreret interview kan kun indeholde ét spørgsmål. Slet de andre spørgsmål for at bruge det integrerede interview.',
      subscriptionNeeded: 'Du skal have et aktivt abonnement for at udgive dit interview.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Introducer kandidater' : 'Introducer kandidaten'),
      descriptionFirst: 'Med introduktionsfunktionen kan du introducere udvalgte kandidater til en kollega eller kunde.',
      descriptionSecond: 'Det er ikke nødvendigt for introduktionsmodtageren at tilmelde sig for at se de introducerede kandidater. Indtast introduktionsmodtagernes e-mailadresser nedenfor. Vælg, hvilke oplysninger om kandidaten, du vil have, at modtagerne kan se. Modtagere vil kun kunne se de valgte oplysninger. Hvis du vælger "Bedømmelse" eller "Kompetencer og kompatibilitet", kan modtagerne indtaste deres bedømmelser og vil også kunne se den gennemsnitlige bedømmelse.',
      descriptionThird: 'Du har også mulighed for at beskytte introduktionerne med en adgangskode, som modtagerne skal indtaste for at kunne se de introducerede kandidater.',
      descriptionFourth: days =>
        `Introduktionslinket udløber om ${days} dage. Du kan forlænge udløbsdatoen i introduktionsindstillingerne. Du kan finde disse indstillinger i menuen "Rediger" under "Rediger introduktioner".`,
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Meddelelsesindhold',
      emailsPlaceholder: 'Modtagers e-mail-adresser',
      namePlaceholder: 'Navn',
      cancel: 'Annuller',
      sendIntroductions: 'Send introduktioner',
      selectedCandidates: count => `${count} kandidater udvalgt til introduktion`,
      successMessage: (candidates, introducees) => `${candidates} kandidater introduceret til ${introducees} personer`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} kandidater introduceret til ${introducees} introducerede. ${isInTeam} fandtes allerede i rekrutteringsteamet.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'findes allerede i rekrutteringsteamet.' : 'findes allerede i rekrutteringsteamet.'),
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      city: 'By',
      coverLetter: 'Følgeskrivelse',
      attachments: 'Vedhæftede filer',
      links: 'Link',
      competencies: 'Kompetencer og kompatibilitet',
      rating: 'Bedømmelse',
      videoResponses: 'Videosvar',
      comments: 'Kommentarer',
      informationsHeader: 'Vælg oplysninger til introduktionen',
      messageHeader: 'Introduktionsmeddelelse',
      usePasscodeText: 'Beskyt introduktionsgruppe med en adgangskode',
      passcode: 'Adgangskode',
      copyToClipboard: 'Kopier kode til udklipsholder',
      generatePasscode: 'Generer ny adgangskode',
      selectAll: 'Vælg alle',
      resetSelection: 'Nulstil valg',
      copySuccess: 'Adgangskode kopieret!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: 'Fortsæt',
    },

    modalInterviewInvite: {
      senderInfo: 'Invitationer sendes fra e-mailadressen invitations@recright.com.',
      replyToEmail: 'E-mailadresse til at besvare samtaleinvitationer',
      replyToName: 'Afsendernavn til samtaleinvitationer',
      replyToInfo:
        'Du kan redigere disse felter på siden til at redigere samtalen.',
      notAnswerable: 'Du kan ikke invitere brugere til lukket samtale eller interview, som ikke har ansvarlige over spørgsmål.',
      title: 'Inviter kandidater',
      description: 'Indtast alle kandidaternes e-mail-adresser. Når de svarer, modtager du besked via e-mail.',
      description2: 'Bemærk, at når du har inviteret kandidater, kan du ikke længere tilføje spørgsmål.',
      smsDescription: 'Når du har sendt invitationer via e-mail, kan du sende SMS-beskeder til kandidaterne',
      addressesPlaceholder: 'Kandidaters e-mail-adresser',
      submit: 'Send invitationer',
      cancel: 'Annuller',
      close: 'Luk',
      templateChangedInfo: 'Du har redigeret invitationen. Ændringen vil blive sendt til denne gruppe modtagere, men vil ikke blive gemt på interviewet.',
      inviteInfo: (newInvitees, stage) => `Invitationen vil blive sendt til ${newInvitees} kandidater blandt de valgte kandidater. Alle valgte kandidater vil blive flyttet til trin "${stage}".`,
      templateSaved: 'Beskeden er nu gemt som skabelon for interviewet.',
      invitesSent: (success, failed) => (failed > 0 ? `${success} invitationer sendt og ${failed} blev allerede inviteret.` : `${success} invitationer sendt.`),
      subscriptionNeeded: 'Du skal have et aktivt abonnement for at invitere kandidater.',
      saveTemplate: 'Gem som denne jobsamtales invitationsmeddelelse',
      rrTemplateOptionLabel: 'Recright standardskabelon',
      interviewTemplateOptionLabel: 'Invitationsmeddelelsen blev gemt for denne jobsamtale',
      templateOptionsLabel: 'Vælg skabelon',
    },

    modalInterviewInviteSms: {
      title: 'Invitationerne blev sendt',
      description: count => `${count} invitationer blev sendt`,
      description2: 'Vil du også sende en SMS-besked til de inviterede kandidater?',
    },

    modalSmsMessage: {
      title: 'Send SMS-besked',
      invitationTitle: 'Send invitation via SMS',
      resendInvitationTitle: 'Send invitation via SMS igen',
      description: count => `Meddelelse bliver sendt til ${count} modtagere`,
      missingInvitationDescription: count => `${count} personer har ikke modtaget en invitation. Skriv venligst invitationsbeskeden nedenfor.`,
      missingPhone: count => `${count} modtagere har ikke et gyldigt telefonnummer.`,
      missingPhone2: 'Tilføj venligst mobiltelefonnumrene i felterne nedenfor.',
      successMessage: count => `${count} SMS-beskeder blev sendt.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} SMS-beskeder blev sendt. Kunne ikke levere ${failedCount} SMS-beskeder.`,
      failedMessage: 'Kunne ikke sende nogen SMS-beskeder til modtagerne',
      phonePlaceholder: 'Telefonnummer',
      recipientsNotFound: 'Der opstod en uventet vejl. Prøv igen senere. Hvis problemet fortsat opstår, bedes du kontakte vores supportafdeling.',
    },

    modalInterviewSelectForEdit: {
      title: 'Rediger detaljer',
      info: 'Vælg det interview, du ønsker at redigere.',
      cancel: 'Anuller',
      done: 'Udført',
      error: {
        selectInterview: 'Vælg venligst interview.',
      },
    },

    modalInterviewStatus: {
      change: 'Skift status for jobsamtale',
      changed: 'Status for jobsamtale ændret',
      changedInfo: 'Status for jobsamtale ændret. Husk at informere kandidaterne omkring beslutninger!',
      info: 'Vælg den nye status for jobsamtalen.',
      open: 'Åben',
      closed: 'Lukket',
      done: 'Udført',
      close: 'Luk',
      endTimeInPast: 'Dette interview har en slutdato, der ligger i fortiden. Hvis du åbner interviewet, bliver slutdatoen fjernet. Du kan indsætte en ny slutdato på ',
      endTimeInPastLink: 'redigeringssiden',
      cancel: 'Annuller',
    },

    modalInterviewTeaser: {
      title: 'Tag det rigtige valg med videointerview',
      content1: 'Videointerview er det naturlige næste trin efter du har modtaget kandidater.',
      upgradeTitle: 'Opgradering 295 EUR/måned',
      upgradeDescription: 'Opgradér din plan til at omfatte 15 videointerviewstillinger pr. år. Din nuværende plan bliver erstattet af dette.',
      singleHireTitle: price => `Engangsleje ${price} EUR/interview`,
      singleHireDescription: 'Brug videointerview til én stilling i løbet af 60 dage. Du kan invitere flere kandidater.',
      tryTitle: 'Prøv gratis',
      tryDescription: 'Lav et videointerview og optag videospørgsmål. Du skal opgradere plan eller købe Enkeltansættelse, før du kan invitere kandidater.',
      contactTitle: 'Kontakt',
      contactDescription: 'Send en kontaktanmodning til os. Vi vender tilbage i løbet af den næste hverdag!',
      cancel: 'Annullér',
      confirm: 'Fortsæt',
      greetings: 'Besked blev afsendt.',
      confirmTitle: 'Bekræft køb',
      confirmDescription: 'Videointerview er ét klik væk. Bekræft betalingen, og du er klar!',
    },

    modalJobAdPreview: {
      title: 'Jobannonceeksempel',
      description: 'Her kan du se, hvordan jobannoncen ser ud for kandidaten.',
      description2: 'Bemærk, at sproget, der anvendes i eksemplet, ikke er det sprog, som er indstillet for jobannoncen.',
      close: 'Luk',
      back: 'Tilbage',
    },

    modalJobAdStatus: {
      change: 'Skift jobstatus',
      changed: 'Jobstatus ændret',
      changedInfo: 'Jobstatus ændret. Husk at informere kandidaterne omkring beslutninger!',
      info: 'Vælg den nye status for jobbet. Når du angiver status til "Udfyldt" eller "Annulleret", ledes du igennem de nødvendige trin i forhold til at vælge de ansatte personer og/eller sende de resterende personer en "Nej tak"-meddelelse',
      open: 'Åben',
      filled: 'Udfyldt',
      cancelled: 'Annulleret',
      done: 'Udført',
      close: 'Luk',
      draft: 'Lukket (kladde)',
      closed: 'Lukket',
      unpublished: 'Ikke publiceret',
      hidden: 'Skjult',
      openDescription: 'Jobannonce offentliggøres frem til',
      filledDescription: 'Luk jobannoncen, fordi stillingen er blevet udfyldt.',
      cancelledDescription: 'Luk jobannoncen, fordi rekrutteringsprocessen er blevet annulleret.',
      closedDescription: 'Jobannoncen er blevet lukket. Jobannoncen er ikke tilgængelig eller synlig for kandidaterne.',
      hiddenDescription: 'Skjul stillingen fra karrieresiden. Stillingen er kun tilgængelig via direkte link:',
      unpublishedDescription: 'Jobopslaget er ikke publiceret. Jobannoncen er ikke tilgængelig eller synlig for kandidaterne.',
      cancel: 'Annullér',
    },

    modalJobPositionTeam: {
      addAnother: 'Tilføj flere brugere ved at indsende deres e-mailadresser',
      team: 'Rekrutteringsteam',
      info: 'Du kan tilføje kollegaer eller andre brugere af hensyn til gennemgang og evaluering af kandidater',
      newMembersMsg: 'Nye teammedlemmer uden en konto i Recright tilføjes den organisation, som stillingen tilhører.* Hvis brugerens mail-domæne ikke stemmer overens med det domæne, der er knyttet til organisationen, vil brugeren kun få minimale brugertilladelser. Brugertilladelserne kan ændres senere af administratorer, der har adgang til brugeradministrationen.',
      asteriskSymbol: '*',
      currentTeam: 'Nuværende team',
      done: 'Udført',
      remove: 'Fjern',
      cancel: 'Annuller',
      selfRemovedMessage: 'Du har fjernet dig selv fra rekrutteringsteamet.',
      submit: 'Tilføj holdmedlemmer',
      successMessage: count => `${count} medlemmer føjet til rekrutteringsholdet.`,
      errors: {
        duplicate: 'Denne e-mail er allerede tilføjet.',
        duplicateMultiple: 'Holdmedlem(mer) allerede fundet med en eller flere af de indsendte e-mailadresser.',
        isEmail: 'E-mailadressen er ugyldig.',
        isEmailMultiple: 'Ugyldige e-mailadresser fundet.',
        isRequired: 'Feltet skal udfyldes.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Er du sikker på, du ønsker at danne en kopi af ${context === 'jobAd' ? 'stillingen' : 'videojobsamtalen'} "${position.title}"?`,
      admins: 'Ønsker du også at kopiere rekrutteringsteamet?',
      done: 'Kopier',
      cancel: 'Annuller',
    },

    modalVideos: {
      title: 'Videobibliotek',
      yourVideos: 'Dine videoer',
      companyVideos: 'Virksomhedens videoer',
      sort: {
        createdAt: 'Oprettelsesdato',
        title: 'Titel',
      },
      add: 'Tilføj',
      done: 'Tilføj videoer',
      cancel: 'Annuller',
    },

    modalUsersAdd: {
      title: 'Inviter brugere',
      languageDescription: 'Disse brugere vil have det følgende sprog:',
      permissionsDescription: 'Disse brugere får følgende tilladelser:',
      emailsPlaceholder: 'Indtast brugerens e-mailadresse',
      seeAllPositions: 'Se alle stillinger',
      createJobPositions: 'Opret stilling',
      createInterviews: 'Opret samtaler',
      account: 'Redigér virksomhedsoplysninger',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Redigér brugere',
      default: 'Standardtilladelser for virksomhed',
      cancel: 'Annullér',
      submit: 'Inviter brugere',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Standardtilladelser for virksomhed:',
      description: 'Alle nye brugere, der registrerer sig for denne virksomhed, vil automatisk blive tildelt standardtilladelserne.',
      seeAllPositions: 'Se alle stillinger',
      createJobPositions: 'Opret stilling',
      createInterviews: 'Opret samtaler',
      account: 'Redigér virksomhedsoplysninger',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Redigér brugere',
      cancel: 'Annullér',
      submit: 'Gem',
    },

    modalOtherApplications: {
      title: 'Kandidat i andre stillinger',
      header: 'Her er en liste over den samme kandidat i andre stillinger',
      close: 'Luk',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Se alle stillinger',
        createJobPositions: 'Opret stilling',
        createInterviews: 'Opret samtaler',
        account: 'Redigér virksomhedsoplysninger',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Redigér brugere',
        default: 'Standardtilladelser',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.",        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Flyt møde',
        confirmRescheduleContent: 'Nogle modtagere har allerede planlagt et møde. Vil du sende nye invitationer? Dette vil overskrive deres tidligere planlagte møde.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      cancel: 'Annuller',
      save: 'Gem',
      addTag: 'Tilføj et tag',
      title: 'Rediger video',
      success: 'Ændringer af videoen blev gemt!',
      error:
        'Vi kunne ikke gemme ændringerne. Prøv igen senere. Hvis problemet fortsætter, bedes du kontakte vores support.',
    },

    noResults: {
      description: 'Din liste er tilsyneladende tom. Hvis du har sat filtre på listen, så prøv at fjerne nogle af dem.',
    },

    notifications: {
      notifications: 'Notifikationer',
    },

    notificationsSubscribeButton: {
      subscribe: 'Abonner',
      subscribed: 'Abonnerede',
      unsubscribe: 'Afmeld',
    },

    onboardTutorial: {
      ui: {
        back: 'Tilbage',
        close: 'Luk',
        last: 'Forrige',
        next: 'Næste',
        skip: 'Sluk',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Velkommen til Recright!',
          text: 'Vi vil guide dig gennem værktøjet med interaktive vejledninger. Du kan se hjælpeteksten for hver funktion ved at klikke på pulsen. Du kan altid får vist vejledninger ved at klikke på dit navn og "Vis tutorial"',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Opret ny stilling',
          text: 'Opret og publicer en ny stilling, og modtag ansøgninger her.',
          selector: '.joyride--add-job-ad',
          position: 'top',
        },
        {
          title: 'Opret ny videosamtale',
          text: 'Opret en ny videosamtale, og inviter kandidater her.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Indstillinger',
          text: 'Skift kontoindstillinger, vælg udseende og URL-adresse for din karriereside, administrer dit videobibliotek, og vælg dit foretrukne sprog her. Du kan også aktivere denne pulsvejledning ved at klikke på "Vis tutorial".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Tilføj hovedbanner og logo',
          text: 'Du kan føje et hovedbanner til stillingsannoncen og gøre den synlig for dine kandidater. Optimal billedstørrelse er 1440 x 320 pixels. Husk også at tilføje dit logo.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Titel, placering, udgivelsesdatoer',
          text: 'Indtast stillingsbetegnelse, lokation, udgivelsesdato og deadline. Hvis Åben indtil ikke udfyldes, er stillingen åben indtil videre.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Jobbeskrivelse',
          text: 'Indtast eller indsæt din jobbeskrivelse her. Husk som minimum at skrive, hvad du søger, hvilke krav der stilles, og hvad du kan tilbyde.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Arbejdsgivervideo',
          text: 'Du kan fremhæve og styrke virksomhedens kultur og employer branding ved at føje en arbejdsgivervideo til jobannoncen.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Opsætning af ansøgningsformular',
          text: 'Vælg, hvilke oplysninger du gerne vil have om dine kandidater. Felterne kan være valgfri eller obligatoriske.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Videospørgsmål',
          text: 'Du kan stille specifikke videospørgsmål til dine kandidater allerede i ansøgningsfasen og gøre ansøgningerne levende gennem videosvar. Dette er samtidig en alletiders mulighed for at hilse på dine kandidater.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Tilføj hovedbanner og logo',
          text: 'Du kan føje et hovedbanner til samtalen og gøre den synlig for dine kandidater. Optimal billedstørrelse er 1440 x 320 pixels. Husk også at tilføje dit logo.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Titel, åben indtil',
          text: 'Indtast en titel for din videosamtale, og angiv en deadline for svar. Hvis du undlader at udfylde "Åben indtil", er samtalen åben indtil videre.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Opsætning af samtale',
          text: 'Vælg, hvilke oplysninger du gerne vil have om dine kandidater. Felterne kan være valgfri eller obligatoriske.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Samtalespørgsmål',
          text: 'Registrer eller overfør dine videospørgsmål. Når du har tilføjet videospørgsmålene, kan du gemme dem i biblioteket og genbruge dem senere. Du kan også bruge tekstspørgsmål, hvis du ikke har mulighed for at bruge videospørgsmål. Kandidater svarer altid med en video.',
          selector: '.joyride--interview-video-questions',
          position: 'bottom-right',
        },
      ],
      createdJobAd: [
        {
          title: 'Handlinger for stilling',
          text: 'Her kan du redigere stillingsbetegnelsen, ændre status og invitere dit team til at evaluere kandidaterne.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: ' Promovér en stilling',
          text: 'Promovér din jobannonce ved at dele den på dine sociale mediekanaler.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Handlinger for videosamtale',
          text: 'Her kan du redigere videointerviewet, ændre status og invitere dit team til at evaluere kandidaterne.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Invitations- og udgivelsesindstillinger',
          text: 'Invitér kandidater, eller udgiv dit videointerview. Derefter kan du promovere og dele det på dine sociale mediekanaler.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Kommentarer og klassificeringer',
          text: 'Du kan kommentere på kandidaterne, klassificere dem med tags, og vurdere dem med stjerner. Husk at angive en passende status for kandidaten, så dit team kender din beslutning. Kandidater kan ikke se denne information.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisationsprofil',
      branding: 'Branding',
      stages: 'Faser',
      emailTemplates: 'E-mailskabeloner',
      competencies: 'Kompetencer',
    },

    passcode: {
      passcode: 'Adgangskode',
      showPasscode: 'Vis adgangskode',
      hidePasscode: 'Skjul adgangskode',
    },

    passwordIndicator: {
      errors: [
        'Adgangskoden skal være på mindst 12 tegn.',
        'Adgangskoden skal være kortere end 128 tegn.',
        'Adgangskoden må ikke indeholde sekvenser med tre eller flere gentagne tegn.',
        'Adgangskoden skal indeholde mindst et lille bogstav: a-z',
        'Adgangskoden skal indeholde mindst et stort bogstav: A-Z',
        'Adgangskoden skal indeholde mindst et tal: 0-9',
        'Adgangskoden skal indeholde mindst et specialtegn: (f.eks. !, #, &)',
      ],
      strengthLabel: 'Adgangskodestyrke: ',
      strengthValue: {
        insufficient: 'Utilstrækkelig',
        weak: 'Svag',
        medium: 'Middel',
        strong: 'Stærk',
      },
      learnMore: 'Lær, hvordan du laver en stærk adgangskode',
    },

    personDetails: {
      namePlaceholder: 'Kandidat',
      links: 'Link',
      attachments: 'Vedhæftninger',
      coverLetter: 'Følgeskrivelse',
      referrer: 'Oprindelse',
      referrerInfo: 'Websitet, som kandidaten kom fra til tjenesten.',
      headerAdditionalInformation: 'Yderligere oplysninger',
      lastSeen: time => `Sidst set ${time}.`,
      state: {
        invited: 'Inviteret',
        visited: 'Besøgt',
        incomplete: 'Ufuldstændig',
        completed: 'Gennemført',
      },
      notVisited: 'Har ikke besøgt på interview.',
      otherPersons: count => `Også fundet i ${count} andre stillinger`,
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      city: 'By',
    },

    personEdit: {
      header: 'Rediger kandidatoplysninger',
      description: context => `Du kan redigere alle grundlæggende kandidatoplysninger, der er synlige for kandidater i ${context === 'application' ? 'ansøgnings' : 'interview'}formularen.`,
      name: 'Kandidatens navn',
      email: 'Kandidatens e-mail',
      phone: 'Kandidatens telefonnummer',
      city: 'Kandidatens nuværende hjemby',
      link: 'Indtast link',
      links: 'Tilføj link, f.eks. LinkedIn-profil',
      coverLetter: 'Følgeskrivelse',
      attachments: 'Vedhæftede filer',
      cancel: 'Annuller',
      save: 'Gem',
      editDetails: 'Rediger oplysninger',
      editSuccess: 'Kandidatoplysninger gemt!',
    },

    personRow: {
      noStage: 'Ikke på noget niveau endnu',
      lastSeen: time => `Sidst set ${time}.`,
      notVisited: 'Har ikke besøgt på interview.',
      selectPerson: 'Vælg',
      deselectPerson: 'Fjern valg',
      openPersonPage: 'Åben',
      icons: {
        messages: messagesSent => `${messagesSent} meddelelser sendt`,
        message: messagesSent => `${messagesSent} meddelelse sendt`,
        noMessages: 'Ingen meddelelser sendt',
        introduction: introductions => `${introductions} introduktion`,
        introductions: introductions => `${introductions} introduktioner`,
        noIntroductions: 'Ingen introduktioner',
        comment: comments => `${comments} kommentar`,
        comments: comments => `${comments} kommentarer`,
        noComments: 'Ingen kommentarer',
        appliedWithLinkedIn: 'Ansøgte via LinkedIn',
      },
      state: {
        invited: 'Inviteret',
        visited: 'Besøgt',
        incomplete: 'Ufuldstændig',
        completed: 'Gennemført',
      },
    },

    pipeline: {
      editInterview: 'Rediger detaljer',
      titleLabel: 'Titel',
      endTimeLabel: 'Åben indtil',
      statusLabel: 'Status',
      locationLabel: 'Sted',
      editStages: 'Rediger trin',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Spor dine kandiater igennem ansættelsesforløbet. Flyt kandidater mellem de forskellige faser i din rekrutterings-pipeline. Du kan filtrere ansøgninger efter faser eller andre kriterier.',
    },

    positionListing: {
      type: 'Type',
      title: 'Titel',
      owner: 'Ejer',
      count: 'Antal',
      invited: 'Inviteret',
      visited: 'Besøgt',
      answered: 'Besvaret',
      hired: 'Ansat',
      leadTime: 'Tidsforbrug',
      leadTimeValue: v => `${v} dage`,
      created: 'Oprettelsesdato (GMT)',
      start: 'Udgivelsesdato (GMT)',
      end: 'Slutdato (GMT)',
      jobAdLabel: 'Jobannonce',
      interviewLabel: 'Videointerview',
      timedLabel: 'Videojobsamtale på tid',
      embedLabel: 'Indlejret jobsamtale',
      publicLabel: 'Offentliggør jobsamtale',
      timezone: 'Timezone',
      feedback: 'Feedbackstatistik',
    },

    qrCodeDownload: {
      download: 'Hent QR-kode',
    },

    recentPositionsContainer: {
      createNew: 'Opret ny',
      showAll: 'Vis alla',
    },

    recentJobAds: {
      openJobPositions: 'Ledige stillinger',
      showAllJobPositions: 'Vis alle stillinger',
      createNewJobPosition: 'Opret ny stilling',
      subscriptionNeeded: 'Du skal have et aktivt abonnement for at offentliggøre din jobsamtale.',
      confirmSingleHire: 'En af dine enkelte ansættelser blev brugt til denne stilling.',
      newApplications: 'Ulæste ansøgninger',
      responses: 'Ansøgninger',
    },

    recentInterviews: {
      openVideoInterviews: 'Åbn videojobsamtaler',
      showAllVideoInterviews: 'Vis alle videojobsamtaler',
      createNewVideoInterview: 'Opret ny videojobsamtale',
      invites: 'Inviterede',
      responses: 'Svar',
      timedTitle: 'Videojobsamtale på tid',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Log på tjenesten',
      password: 'Adgangskode',
      confirmPassword: 'Gentag adgangskode',
      agreeTos: 'Jeg har læst, og jeg godkender ',
      agreeTosLinkText: 'Brugervilkårene og betingelserne for Recright.',
      privacyPolicy: 'Jeg har gjort mig bekendt med ',
      privacyPolicyLinkText: 'Privatlivspolitikken.',
      licenseAgreement: 'På vegne af den organisation, jeg repræsenterer, accepterer jeg ',
      licenseAgreementLinkText: 'Recrights generelle tjenestevilkår.',
      newsletter: 'Tilmeld dig månedligt nyhedsbrev.',
      name: 'Navn',
      namePlaceholder: 'Fornavn Efternavn',
      organization: 'Organization',
      companyDomain: domain => `Tillad brugere at tilmelde sig med domænet  ${domain} for at blive føjet til denne virksomhed.`,
      error: {
        password: {
          isRequired: 'Adgangskode er påkrævet. ',
          isValidPassword: 'En gyldig adgangskode skal være på mindst 12 tegn og omfatte mindst et stort bogstav, et lille bogstav og et tal.',
          passwordsMatch: 'Adgangskoderne passer ikke sammen.',
        },
      },
    },

    requestCustomPlan: {
      info: 'Har du større mængder?',
      cta: 'Anmod om tilbud for en specialtilpasset plan',
      successMessage: 'Anmodning blev afsendt.',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Kontakt den faktureringsansvarlige i din organisation.',
    },

    search: {
      placeholder: 'Søg',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Sted',
        status: 'Status',
        state: 'Fremskridt',
        tags: 'Tags',
        rating: 'Bedømmelse',
        stage: 'Niveau',
      },
      state: {
        invited: 'Inviteret',
        visited: 'Besøgt',
        incomplete: 'Ufuldstændig',
        completed: 'Gennemført',
      },
      status: {
        hired: 'Ansat',
        proceed: 'Fortsæt',
        new: 'Ny',
        all: 'Alle',
        videointerviewed: 'Videojobsamtale',
        personalinterview: 'Personlig jobsamtale',
        withdrawn: 'Meldt ud',
        scheduledinterview: 'Planlagt jobsamtale',
        rejected: 'Afvist',
        open: 'Åben',
        filled: 'Udfyldt',
        cancelled: 'Annulleret',
        closed: 'Lukket',
        draft: 'Lukket (kladde)',
        unpublished: 'Ikke publiceret',
        hidden: 'Skjult',
        finished: 'Færdig',
        coming: 'Kommende',
        active: 'Igangværende',
      },
    },

    selectListings: {
      title: 'Opslag',
      description: 'Vælg opslag, hvor stillingen blev slået op.',
    },

    session: {
      account: 'Kontoadministration',
      language: 'Sprog',
      logout: 'Log af',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Recright-kurser',
      expired: 'Log på igen.',
      showTutorial: 'Vis tutorial',
      helpCenter: 'Recright Help Center',
      organization: 'Organization',
    },

    showFeedbackPulse: {
      showPulse: 'Vis feedback',
      positive: avg => `${avg}% Positiv`,
      feedbackStatistics: 'Feedbackstatistik',
      noFeedback: 'Ingen feedback endnu',
      responses: responses => `${responses} Svar`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Du har ${count} enkelte ansættelser tilbage på din konto.`,
      notificationBody: 'Ved at invitere eller udgive interviewet, bruges en enkelt ansættelse.',
    },

    singleHires: {
      currentCount: count => `${count} enkelte ansættelser tilbage.`,
      purchase: 'Køb en enkelt ansættelse',
      label: 'Enkelt ansættelse',
      confirmMessage: amount => `Bekræft dit køb af en enkelt ansættelse. ${amount} EUR bliver trukket fra dit betalingskort.`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruiters-integration',
      description: 'Du kan tilføje og fjerne enkelte interviews fra listen Videointerview i Smartrecruiters.',
      notification: 'Bemærk, at det kan tage op til 24 timer, før interviewene kan ses i Smartrecruiters.',
      addButton: 'Føj til Smartrecruiters',
      removeButton: 'Fjern fra Smartrecruiters',
      confirmRemove: 'Er du sikker på, at du vil fjerne interviewet fra Smartrecruiters?',
      addConflict: 'Interviewet er allerede føjet til listen Videointerview',
      removeConflict: 'Interviewet er allerede fjernet fra listen Videointerview',
    },

    subscriptionExpired: {
      message: 'Dit abonnement er udløbet.',
    },

    subscriptionPlan: {
      plan: 'Plan',
      noActivePlan: 'Du har ikke en aktiv plan.',
      changePlan: 'Skift plan.',
      createSubscription: 'Opret et nyt abonnement',
      save: 'Gem',
      cancel: 'Annuller',
      errorFromProcessor: error => `Betalingshåndtering svarede med fejl: ${error}`,
    },

    stars: {
      yourRating: rating => `Din bedømmelse: ${rating}`,
      totalVotes: count => `'I alt ${count} vurderinger`,
      yourRatingReset: 'Nulstil din stemme',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Åben',
        filled: 'Udfyldt',
        cancelled: 'Annulleret',
        closed: 'Lukket',
        draft: 'Kladde',
        hidden: 'Skjult',
        unpublished: 'Ikke publiceret',
      },
      person: {
        hired: 'Ansat',
        proceed: 'Fortsæt',
        new: 'Ny',
        videointerviewed: 'Videojobsamtale',
        personalinterview: 'Personlig jobsamtale',
        withdrawn: 'Meldt ud',
        scheduledinterview: 'Planlagt jobsamtale',
        rejected: 'Afvist',
      },
    },

    transactionList: {
      noTransactions: 'Ingen transaktioner',
      createdAt: 'Oprettet',
      type: 'Type',
      status: 'Status',
      amount: 'Beløb',
      receipt: 'Kvittering',
      statuses: {
        authorization_expired: 'Godkendelse',
        authorized: 'Godkendt',
        authorizing: 'Godkender',
        settlement_pending: 'Betaling afventer',
        settlement_confirmed: 'Betaling bekræftet',
        settlement_declined: 'Betaling afvist',
        failed: 'Mislykkedes',
        gateway_rejected: 'Gateway afvist',
        processor_declined: 'Processor afvist',
        settled: 'Betalt',
        settling: 'Betaler',
        submitted_for_settlement: 'Sendt til betaling',
        voided: 'Annulleret',
      },
      types: {
        sale: 'Salg',
        credit: 'Kredit',
      },
      download: 'Hent',
      downloadReceipt: 'Download kvittering',
      notSettled: 'Venter på betaling',
    },

    trialBanner: {
      notification: days => `Du har ${days} dage tilbage af din prøveperiode. Hvis du ønsker at fortsætte efter prøveperioden, beder vi dig købe enten abonnement eller single hire-produktet.`,
      trialEnded: 'Din prøveperiode er slut nu. Venligst køb abonnement eller single hire for at fortsætte med at bruge tjenesten.',
      orderHere: 'Abonnér her',
    },

    updateCreditCard: {
      save: 'Gem',
      cancel: 'Annuller',
    },

    favorite: {
      popupHeader: 'Vælg videobibliotek',
      yourVideos: 'Dine videoer',
      companyVideos: 'Virksomhedens videoer',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Tilføj film til dine favoritter ved at klikke på hjerteikonet. Du kan fjerne film fra dine favoritter gennem <a href="${videoLibrary}">Videobibliotek</a>.`,
    },

    brandingPreview: {
      preview: 'Eksempel',
      header: 'Overskrifteksempel',
      body: lorem => `Dette er et skrifttypeeksempel. ${lorem}`,
      linkText: 'Dette er et linkeksempel.',
      primaryButtonText: 'Primær knap',
      secondaryButtonText: 'Sekundær knap',
      backButtonText: 'Tilbage-knap',
    },

    usersList: {
      generalInformation: 'Generelle oplysninger',
      latestVisit: date => `Seneste besøg ${date}`,
      neverLogger: 'Har aldrig været logget på',
      externalUser: 'Ekstern bruger',
      inviteExpired: 'Invitation udløbet',
      permissions: {
        permissions: 'Tilladelser',
        seeAllPositions: 'Se alle stillinger',
        createJobPositions: 'Opret stilling',
        createInterviews: 'Opret samtaler',
        account: 'Redigér virksomhedsoplysninger',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Redigér brugere',
        default: 'Standardtilladelser',
      },
      actions: {
        actions: 'Handlinger',
        activate: 'Aktivér',
        deactivate: 'Deaktivér',
        removeFromOrganisation: 'Fjern fra organisationen',
        hiddenPositions: 'Skjulte stillinger',
      },
      noUsers: 'Ingen brugere. Prøv at reducere antallet af filtre, hvis du har filtreret listen.',
    },

    usersListFilters: {
      sort: {
        name: 'Navn',
        email: 'E-mail',
        lastAdminAccess: 'Seneste administratoradgang',
      },
      find: 'Søg',
      clearSelections: 'Ryd markeringer',
      usersCount: count => `I alt ${count} brugere`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Redigér tilladelser for flere brugere',
      deactivateSelectedUsers: 'Deaktivér valgte brugere',
      activateSelectedUsers: 'Aktivér valgte brugere',
      addNewUsers: 'Inviter brugere',
      save: 'Gem',
      cancel: 'Annullér',
      editUsersPermissions: 'Redigér brugertilladelser',
    },

    linkedInInformation: {
      title: 'LinkedIn-oplysninger:',
      since: 'Siden',
      summary: 'Resumé:',
      fullLinkedInProfile: 'Komplet LinkedIn-profil',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-mail blev afvist. Kontroller, om modtageren har modtaget din meddelelse.',
      },
      Permanent: {
        General: 'E-mail kunne ikke leveres. Modtagerens e-mailudbyder afviste meddelelsen.',
        NoEmail: 'E-mailadressen findes ikke.',
        Suppressed: 'E-mail blev ikke leveret på grund af tidligere mislykkede leveringsforsøg.',
      },
      Transient: {
        General: 'E-mail blev afvist. Kontroller, om modtageren har modtaget din meddelelse.',
        MailboxFull: 'Modtagerens indbakke er fuld.',
        MessageTooLarge: 'Meddelelsens indhold er for stort.',
        ContentRejected: 'Meddelelsens indhold afvist.',
        AttachmentRejected: 'Vedhæftet fil afvist.',
      },
    },

    videoBackgroundUpload: {
      header: 'Organisationens videobaggrundsbillede',
      description:
        'Billedet, som din organisations brugere kan bruge som baggrundsbillede til de videoer, de optager.',
      add: 'Tilføj videobaggrundsbillede',
      info: 'Den anbefalede billedstørrelse er 720x480 pixels.',
    },
  },

  page: {
    account: {
      title: 'Kontoadministration',
      details: 'Kontooplysninger',
      name: 'Kontonavn',
      save: 'Gem',
      saved: 'Kontooplysninger gemt.',
      signature: 'Underskrft',
      permissions: 'Tilladelser',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Adgangskode',
      statistics: 'Statistics',
      organization: 'Organization',
    },

    actionBar: {
      selection: 'valgt',
    },

    organisationProfile: {
      title: 'Organisationsprofil',
      details: 'Indstillinger for organisationsprofil',
      brandingHeader: 'Organisationsbranding',
      name: 'Organisationsnavn',
      customReplyToSubtitle:
        'Her kan du redigere afsendernavnet og svaradressen til samtaleinvitationerne. Hvis feltet efterlades tomt, bruges navnet og e-mailadressen på den bruger, der sender invitationerne.',
      customReplyToEmail: 'E-mailadresse til at besvare samtaleinvitationer',
      customReplyToName: 'Afsendernavn til samtaleinvitationer',
      senderInfoDisabled:
        'Opdatering af afsenderoplysningerne om samtaleinvitationer er deaktiveret, fordi videosamtaler er deaktiveret for din organisation.',
      owner: 'Kontoindehaver',
      slug: 'URL for karriereside',
      slugUnavailable: 'Denne URL er allerede reserveret',
      slogan: 'Slogan for karriereside',
      language: 'Sprog for karriereside',
      languagePlaceholder: 'Vælg',
      rss: 'RSS-feed til karrierer',
      type: 'Kontotype',
      types: {
        free: {
          title: 'Fri',
          description: 'Fordele ved fri\n1 bruger\n1 ledig stilling ad gangen',
        },
        basic: {
          title: 'Basic',
          description: 'Fordele ved fri\nUbegrænsede ledige stillinger\nVideojobsamtaler',
        },
        team: {
          title: 'Team',
          description: 'Fordele ved team\nUbegrænsede ledige stillinger\nVideojobsamtaler\nKandidatpræsentationer',
        },
      },
      save: 'Gem',
      reset: 'Reset',
      saved: 'Organisationsoplysninger gemt.',
      companyAdminUsers: 'Company admin users',
      cancel: 'Annuller',
      confirmLeave: 'Du har ugemte ændringer. Er du sikker på, at du vil afslutte?',
      error: {
        required: '* Felterne mærket med en stjerne er obligatoriske.',
      },
      emailBrandingHeader: 'Branding af e-mail',
      emailBrandingDescription:
        'Tilpas farverne på de e-mail, der sendes til kandidaterne.',
    },

    organisationCompetencies: {
      title: 'Organisationens kompetencer',
      description: 'Du kan redigere, tilføje og slette organisationens kompetencer her. Dette vil blive standardkompetencerne i nye stillinger oprettet for denne virksomhed og kan findes hos kandindater i disse stillinger i afsnittet "Kompetencer og kompatibilitet".',
    },

    organisationStages: {
      title: 'Organisationens rekrutteringsfaser',
      description: 'Du kan redigere, tilføje, slette og omorganisere organsationens faser her. Dette bliver standardfaser for rekruttering til nye stillinger, der oprettes for denne virksomhed.',
    },

    organisationEmailTemplates: {
      preview:
        'Se et eksempel på e-mailen (eksemplet har ikke al formatering, som den endelige e-mail har)',
      preview2:
        'E-mailskabelonens farver kan tilpasses på organisationens side med brandingindstillinger.',
      timedInterviewPreviewInfo:
        'Meddelelsen til videojobsamtale på tid indeholder ikke den del, der handler om at kontakte supportafdelingen.',
      templateTypes: {
        interviewInvite: 'Invitation til videointerview',
        timedInterviewInvite: 'Invitation til videointerview på tid',
        interviewCompleted: 'Interview fuldført / takkemeddelelse til kandidater',
        applicationCompleted:
          'Jobansøgning fuldført / takkemeddelelse til jobansøger',
      },
      subHeaders: {
        jobAdLabel: 'Jobannonce',
        interviewLabel: 'Videointerview',
      },
      deleteTemplate: 'Slet skabelon',
      confirmation: templateName =>
        `Er du sikker på, at du vil slette skabelonen "${templateName}" fra din organisations e-mailskabeloner?`,
      deleteSuccess:
        'Skabelonen blev slettet fra organisationens e-mailskabeloner.',
      emailTemplateInfo: 'Du kan i øjeblikket kun gemme én skabelon med ét sprog.',
      templateError: 'Template with same name or language already exists',
    },

    application: {
      lastSeen: time => `Sidst set ${time}.`,
      notVisited: 'Har ikke besøgt på interview',
      back: 'Tilbage til ansøgningsliste',
      delete: 'Slet ansøgning',
      deleted: 'Ansøgning slettet',
      interviewClosed: 'Interviewet er lukket',
      resendInvitation: 'Send invitation til ansøger igen',
      changeStage: 'Flyt til et andet niveau',
      commentsAndClassifications: 'Kommentarer og klassificeringer',
      openingTitle: title => `Videojobsamtale - ${title}`,
      yourRatingText: 'Din bedømmelse:',
      competencesAndCompatibility: 'Kompetencer og kompatibilitet',
      duplicateCompetency: 'Kompetence eksisterer allerede',
      competencyNotFound: 'Kompetence ikke fundet eller fjernet',
      confirmDelete: 'Er du sikker på, at du vil slette denne ansøgning?',
      stageChanged: 'Storartet!',
      stageChangedInfo: stage => `Nu har du flyttet disse kandidater til niveauet "${stage}", så giv dem besked om det. Send dem en e-mail eller en videobesked.`,
      close: 'Luk',
      changestageTooltip: 'Du kan se den aktuelle fase, kandidaten befinder sig i. Du kan indstille fasen manuelt ved at klikke på den ønskede fase. Kandidaten får ikke besked om dette.',
      commentsTooltip: 'Du kan skrive kommentarer vedrørende kandidatens ansøgning, som dine kolleger kan se. Kandidaten kan ikke se disse oplysninger.',
      competencesTooltip: 'Du kan tilføje eller bedømme en kompetence. Dine kolleger kan se og bedømme de kompetencer, du har tilføjet, samt oprette nye. Kandidaten kan ikke se disse oplysninger.',
      actionlogTooltip: 'Kommentarer, faseændringer, meddelelser og andre aktiviteter vises her. Kandidaten kan ikke se disse oplysninger.',
      reopenProcessConfirm: 'Er du sikker på, at du ønsker at flytte denne kandidat væk fra trinnet "Meldt ud" og tilbage til rekrutteringsprocessen? Når du har bekræftet, vil kandidaten igen kunne fuldføre jobsamtaler, som vedkommende endnu ikke har færdiggjort.',
      withdrawConfirm: 'Er du sikker på, at du ønsker at mede denne kandidat ud af rekrutteringsprocessen? Hvis vedkommende meldes ud, kan kandidaten ikke længere fuldføre jobsamtaler, som vedkommende er inviteret til.',
      state: {
        invited: 'Inviteret',
        visited: 'Besøgt',
        incomplete: 'Ufuldstændig',
        completed: 'Gennemført',
      },
      stage: {
        hired: 'Ansat',
        proceed: 'Fortsæt',
        new: 'Ny',
        videointerviewed: 'Videojobsamtale',
        personalinterview: 'Personlig jobsamtale',
        withdrawn: 'Meldt ud',
        scheduledinterview: 'Planlagt jobsamtale',
        rejected: 'Afvist',
      },
    },

    billing: {
      title: 'Fakturering',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Den næste fakturering vil være ${nextBillingPeriodAmount} EUR d. ${nextBillingDate}`,
      status: 'Status',
      singleHire: 'Enkelt ansættelse',
      billingOverview: 'Faktureringsoversigt',
      payment: 'Betaling',
      paymentHistory: 'Betalingshistorik',
      updateDetails: 'Opdatér faktureringsoplysninger',
      billingStatus: {
        pending: 'Afventer',
        active: 'Aktiv',
        pastdue: 'Forfalden',
        expired: 'Udløbet',
        canceled: 'Annulleret',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Handling log',
      back: 'Tilbage til kandidatliste',
      delete: 'Slet kandidat',
      deleted: 'Kandidat slettet',
      interviewClosed: 'Interviewet er lukket. Der blev ikke sendt nogen geninvitationer.',
      resendInvitation: 'Send invitation til kandidat',
      changeStage: 'Flyt til et andet niveau',
      introducedTo: 'Introduceret til:',
      yourRatingText: 'Din bedømmelse:',
      competencesAndCompatibility: 'Kompetencer og kompatibilitet',
      duplicateCompetency: 'Kompetence eksisterer allerede',
      competencyNotFound: 'Kompetence ikke fundet eller fjernet',
      confirmDelete: 'Er du sikker på, at du vil slette denne kandidat?',
      stageChanged: 'Storartet!',
      stageChangedInfo: stage => `Nu har du flyttet disse kandidater til niveauet "${stage}", så giv dem besked om det. Send dem en e-mail eller en videobesked.`,
      close: 'Luk',
      hideStages: 'Skjul faser',
      showStages: 'Vis faser',
      resetQuestionResponseSuccess: 'Kandidatens svar blev slettet',
      stage: {
        hired: 'Ansat',
        proceed: 'Fortsæt',
        new: 'Ny',
        videointerviewed: 'Videojobsamtale',
        personalinterview: 'Personlig jobsamtale',
        withdrawn: 'Meldt ud',
        scheduledinterview: 'Planlagt jobsamtale',
        rejected: 'Afvist',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'Live interviews',
      showAllLiveInterviews: 'Show all live interviews',
      createNewLiveInterview: 'Create new live interview',
      welcome: name => `Velkommen, ${name}!`,
      liveCard: {
        startTime: 'Start time',
        interviewers: 'Interviewers',
        candidates: 'Candidates',
      },
    },

    interviewEdit: {
      title: 'Titel',
      titleLabel: 'Titel på jobsamtale',
      location: 'Sted',
      publishTimePlaceholder: 'Offentligøringsdato',
      publishTimeTooltip: 'Angiv en udgivelsesdato for jobsamtalen. Du kan ændre datoen når som helst.',
      endTime: 'Åben indtil',
      endTimeTooltip: 'Vælg en lukkedato for ansøgningsperioden.',
      timezone: 'Tidszone',
      isNotPastDate: 'Den indtastede dato skal være efter dags dato.',
      interviewIsClosed: 'Interviewet er lukket i øjeblikket. Vil du ',
      interviewIsClosedLink: 'åbne det',
      edit: {
        details: 'Rediger detaljer',
        status: 'Skift status',
        team: 'Rediger team',
      },
      questions: 'Spørgsmål til jobsamtale',
      answerable: 'Spørgsmål kan besvares',
      questionsDescription: 'Dette er spørgsmål, som deltagerne bliver bedt om at besvare.',
      questionsNotEditable: 'Spørgsmål kan ikke redigeres efter invitationer er sendt.',
      saved: 'Jobsamtale gemt',
      deleted: 'Jobsamtale slettet',
      delete: 'Slet jobsamtale',
      cancel: 'Annuller',
      save: 'Gem',
      language: 'Sprog for jobsamtale',
      languagePlaceholder: 'Vælg',
      languages: {
        en: 'Engelsk',
        fi: 'Finsk',
      },
      confirmLeave: 'Du har ugemte ændringer. Er du sikker på, at du vil afslutte?',
      OnboardingHeadImageSize: 'Anbefalet størrelse billede til hovedbanner er 1440px*320px eller mere.',
      takeLimitLabel: 'Antal optagelser',
      preparationTimeLabel: 'Forberedelsestid',
      answerTimeLabel: 'Svartid',
      confirmHeader: 'Er du sikker på, at du vil slette dette interview?',
      integratedConfirmContent: 'Dette interview er integreret i et andet system, hvis du fjerner det, kan det skabe fejl med integrationen.',
    },

    interview: {
      endTime: date => (date ? `indtil ${date}` : ''),
      edit: 'Rediger detaljer',
      copy: 'Kopier videojobsamtalen',
      editInvitation: 'Rediger invitationen',
      editMenu: 'Rediger',
      editTeam: 'Rediger team',
      questions: 'Spørgsmål til jobsamtale',
      changeStatus: 'Skift status',
      publishSettings: 'Offentliggør indstillinger',
      invite: 'Inviter kandidater',
      showCandidates: 'Vis kandidater',
      oneError: ' Indlejret jobsamtale kan kun have ét spørgsmål.',
      copySuccess: 'Videojobsamtalen er blevet succesfuldt kopieret',
      editIntroduceBatches: 'Rediger introduktioner',
      editEmailSettings: 'Rediger e-mailindstillinger',
    },

    interviews: {
      allInterviews: 'Alle videojobsamtaler',
      createNewVideoInterview: 'Opret ny videojobsamtale',
      filter: 'Søg efter jobsamtaler',
      invites: 'Inviterede',
      responses: 'Svar',
      sort: {
        title: 'Titel',
        publishTime: 'Udgivelsesdato',
        endTime: 'Slutdato',
        createdAt: 'Oprettelsesdato',
        updatedAt: 'Sidst ændret',
        answeredCount: 'Kandidater',
      },
    },

    interviewCandidates: {
      preview: 'Eksempel',
      endTime: date => (date ? `Åben indtil ${date}` : ''),
      publicTitle: 'Offentliggør jobsamtale',
      embedTitle: 'Indlejret jobsamtale',
      placeholder: {
        first: 'Endnu ingen kandidater.',
        second: 'Du kan også gøre dit videointerview offentligt.',
        third: 'Så alle interesserede i stillingen kan se det offentlige interview og søge om det.',
        fourth: 'Glem heller ikke, at alle disse kun er et klik med en knap væk i titelbjælken ovenfor.',
      },
      title: 'Alle kandidater',
      sort: {
        default: 'Default',
        updatedAt: 'Sidst ændret',
        name: 'Navn',
        rating: 'Bedømmelse',
        createdAt: 'Oprettelsesdato',
      },
      sendMessage: 'Send meddelelse',
      changeStage: 'Flyt til et andet niveau',
      introduce: 'Introducer',
      filter: 'Søg efter kandidater',
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
      emailSent: 'E-mail afsendt!',
      interviewClosedError: 'Du kan ikke gen-invitere en kandidat til et videointerviw, der er lukket.',
      excel: 'Eksporter alle kandidater',
      reInviteSent: candidates => `${candidates} invitationer sendt igen!`,
    },

    jobAdEdit: {
      preview: 'Forhåndvis',
      confirm: 'Er du sikker på, at du vil tilføje dette job?',
      deleteHeader: 'Er du sikker på, at du vil slette dette job?',
      deleteContent: 'Hvis du sletter dette job, fjerner du også alle relaterede oplysninger om jobbet såsom ansøgninger og videointerviews.',
      titlePlaceholder: 'Jobtitel',
      locationPlaceholder: 'Sted',
      timezone: 'Tidszone',
      endTimePlaceholder: 'Åben indtil',
      endTimeTooltip: 'Vælg en lukkedato for ansøgningsperioden.',
      isNotPastDate: 'Den indtastede dato skal være efter dags dato.',
      publishTimePlaceholder: 'Offentligøringsdato',
      publishTimeTooltip: 'Indstil en udgivelsesdato for jobannoncen. Du kan ændre datoen, når du vil.',
      language: 'Sprog',
      languagePlaceholder: 'Vælg',
      languages: {
        en: 'Engelsk',
        fi: 'Finsk',
      },
      description: 'Jobbeskrivelse',
      saved: 'Job gemt',
      deleted: 'Job slettet',
      descriptionPlaceholder: 'Indtast jobskrivelsen her. \n\nDet er muligt at forbedre beskrivelsen med tekstformateringsværktøjerne herunder.',
      createInviteOnly: 'Opret videojobsamtale med invitation alene',
      delete: 'Slet job',
      cancel: 'Annuller',
      save: 'Gem',
      confirmLeave: 'Du har ugemte ændringer. Er du sikker på, at du vil afslutte?',
      singleHireEndError: 'Man kan ikke bruge single hire i mere end 60 dage.',
      OnboardingHeadImageSize: 'Anbefalet størrelse billede til hovedbanner er 1440px*320px eller mere.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, åben indtil ${date}` : ''),
      title: 'Alle ansøgninger',
      sort: {
        updatedAt: 'Sidst ændret',
        name: 'Navn',
        rating: 'Evaluering',
        createdAt: 'Oprettelsesdato',
      },
      add: 'Opret ny ansøgning',
      inviteToInterview: 'Inviter til jobsamtale',
      sendMessage: 'Send meddelelse',
      changeStage: 'Flyt til et andet niveau',
      introduce: 'Introducer',
      filter: 'Søg efter ansøgninger',
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
      editIntroduceBatches: 'Rediger introduktioner',
      addInterviewConfirm: jobAd => `Ønsker du at skabe et nyt video-interview knyttet til jobbet "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      city: 'By',
      back: 'Tilbage',
      continue: 'Fortsæt',
      submit: 'Tilføj',
      namePlaceholder: 'Kandidatens navn',
      emailPlaceholder: 'Kandidatens e-mail',
      cityPlaceholder: 'Kandidatens nuværende hjemby',
      links: 'Tilføj link, f.eks. LinkedIn-profil',
      legendLinks: 'Link',
      legendAttachments: 'Vedhæftede filer',
      legendAdditionalFields: 'Yderligere oplysninger',
      legendBasicInfo: 'Grundlæggende oplysninger',
      coverLetter: 'Følgeskrivelse',
      attachments: 'Vedhæftede filer',
      introduction: 'Skriv din introduktion her',
      thankYou: 'Mange tak.',
      readyInfo: 'Tak. Kandidaten er nu tilføjet stillingen.',
      close: 'Luk',
      required: '* Felterne mærket med en stjerne er obligatoriske.',
      excel: 'Eksporter alle ansøgninger',
    },

    jobAdPreview: {
      endTime: date => (date ? `, åben indtil ${date}` : ''),
      exit: 'Afslut gennemgang',
      description: 'Jobbeskrivelse',
      video: 'Medarbejdervideo',
      questions: 'Videospørgsmål',
      apply: 'Ansøg om stilling',
    },

    jobAd: {
      endTime: date => (date ? `, åben indtil ${date}` : ''),
      changeStatus: 'Skift jobstatus',
      edit: 'Rediger job detaljer',
      copy: 'Kopier stilling',
      editInvitation: 'Rediger invitationen',
      editTeam: 'Rediger team',
      editMenu: 'Rediger',
      description: 'Jobbeskrivelse',
      video: 'Arbejdsgivervideo',
      questions: 'Videospørgsmål',
      apply: 'Ansøg om stilling',
      showApplications: 'Vis ansøgninger',
      publicLink: 'Jobannoncen offentligt side',
      copySuccess: 'Stillingen er blevet succesfuldt kopieret',
    },

    jobAds: {
      subscriptionNeeded: 'Du skal have et aktivt abonnement for at offentliggøre din jobsamtale.',
      responses: 'Ansøgninger',
      createNewJobPosition: 'Opret ny stilling',
      allJobPositions: 'Alle stillinger',
      confirmSingleHire: 'One of your purchased single hires are used for this position.',
      filter: 'Søg stillinger',
      sort: {
        title: 'Titel',
        publishTime: 'Udgivelsesdato',
        applicationCount: 'Ansøgninger',
        endTime: 'Slutdato',
        createdAt: 'Oprettelsesdato',
        updatedAt: 'Sidst ændret',
      },
    },

    jobAdSaved: {
      title: 'Stilling gemt!',
      description: 'Din jobannonce er nu blevet gemt. Her er et offentligt link til jobannoncen:',
      addApplication: 'Direkte link til ansøgningsformularen:',
      toDashboard: 'Forside',
      toJobAd: 'Tilbage til jobannoncen',
    },

    live: {
      title: 'Live interview',
      editTitle: 'Rediger live interview',
      startTimeTitle: 'Starttidspunkt for interview',
      startTime: 'Starttidspunkt',
      interviewers: 'Interviewere',
      candidates: 'Kandidater',
      messageLabel: 'Invitationsbesked',
      create: 'Opret ny live interview',
      save: 'Gem live interview',
      cancel: 'Annuller',
      removeLive: 'Fjern live interview',
      cancelLive: 'Annuller live interview',
      comment: 'Tilføj en ny kommentar',
      commentLabel: 'Kommentarer',
      enter: 'Deltag i live interview',
      edit: 'Tilføj/fjern deltagere',
      draft: 'Ny live interview',
      pending: 'Waiting for candidate confirmation',
      customNotConnectedNote:
        "User's calendar is not connected to Recright and their availability cannot be checked.",
      scheduledLiveCandidateSubtitle:
        'For the scheduled live interview you can only add one candidate.',
      confirmHeader: 'Er du sikker på, at du vil slette dette interview?',
      inviteFailure: (success, failed) =>
        `${success} invitationer sendt og ${failed} kunne ikke sendes!`,
      inviteSuccess: success => `${success} invitationer sendt.`,
      recordingsHeaderWithTitle: title =>
        `Optagelser til direkte jobsamtale ${title}`,
      recordingsHeader: `Optagelser til direkte jobsamtale`,
      success: {
        create: 'Ny live interview oprettet',
        delete: 'Live interview fjernet',
        update: 'Live interview opdateret',
      },
      placeholders: {
        candidateEmails: 'Tilføj kandidat',
        interviewerEmails: 'Tilføj interviewer',
        emailTitle: 'Titel',
        emailMessage: 'Besked',
        emailName: 'Navn',
      },
    },

    lives: {
      allLives: 'Alle live interviews',
      createNewLive: 'Opret ny live interview',
      filter: 'Søg efter kandidater',
      candidates: 'Kandidater',
      sort: {
        title: 'Titel',
        startTime: 'Starttidspunkt',
        createdAt: 'Oprettelsesdato',
      },
    },

    login: {
      title: 'Log på tjenesten',
      register: 'Tilmeld',
      ldap: 'Log på med LDAP-integration',
      forgot: 'Glemt adgangskode?',
      normal: 'Normal log in',
      ssoLogin: 'SSO-login',
    },

    publicSubscribe: {
      intro: 'Vælg en passende plan, angiv dine betalingsoplysninger og brug videorekrutteringsredskabet med det samme. Alle dine betalinger behandles sikkert at vores betalingsprocessor Braintree.',
      headline: 'Abonnementsform',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Producs',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: 'Tak!',
      existingDescription: 'Vi har nu modtaget dine abonnementoplysninger, og du kan fortsætte med at bruge videorekrutteringsredskabet.',
      newUserDescription: 'Vi har oprettet en konto til dig og sendt oplysninger om hvordan du indstiller din adgangskode.',
    },

    quickInterview: {
      title: 'Lynvideojobsamtale',
      description: 'Med henblik på at lære dig hurtigere at kende vil vi gerne bede dig besvare vores lynjobsamtalespørgsmål kortfattet. Få din personlighed med, og giv din ansøgning sjæl.',
      requiredNote: 'Bemærk, at det er en del af ansøgningsprocessen, og at rekrutteringsagenten først modtager din ansøgning, når du har registreret dit svar.',
      reminderNote: 'Du kan optage svaret med det samme, eller du kan fortsætte på et senere tidspunkt ved at modtage en påmindelse via e-mail.',
    },

    register: {
      title: 'Designet til rekruttering!',
      leadText: 'Recright er en brugervenlig, videobaseret rekrutteringsplatform til rekrutteringsmedarbejdere og ansættende chefer. Du kan opslå ledige stillinger, modtage ansøgninger og gennemføre videointerviews – alt sammen på ét sted! Vores værktøj har hjulpet mere end 400 virksomheder med at finde de rigtige medarbejdere, og din virksomhed kan blive den næste! Tilmeld dig herunder og begynd at rekruttere!',
      email: 'Email',
      submit: 'Tilmeld dig',
      alreadyMember: 'Allerede medlem?',
      onlyForRecruiters: 'Denne tilmelding er kun for rekrutteringsmedarbejdere og ansættende chefer.',
      login: 'Log ind here.',
      registerSuccess: 'En emailinvitation er blevet sendt til dig.',
      domainError: 'Registrer dig med din virksomheds e-mailadresse.',
      companyExistsMessage: 'Tjek din e-mail for instruktioner!',
    },

    searchResults: {
      title: 'Søgeresultater',
      applications: 'Ansøgninger',
      candidates: 'Kandidater',
      noApplications: 'Ingen ansøgninger, der matcher søgekriterierne',
      noCandidates: 'Ingen kandidater passer til søgekriterierne',
      query: query => (query ? `Search query: ${query}` : ''),
      noStage: 'Ikke på noget niveau endnu',
      search: 'Søg',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Titel',
        owner: 'Owner',
        createdAt: 'Oprettelsesdato',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'Tilmeld dig',
    },

    welcomeMulticompany: {
      welcome: companyName => `Velkommen til ${companyName}`,
      successMessage: companyName =>
        `Du er nu blevet føjet til organisationen ${companyName}!`,
      navigationInfo:
        'Du kan ændre din aktuelle organisation via navigationslinjen øverst til højre.',
      login: 'Login here',
    },

    forgotPassword: {
      title: 'Indstilling af ny adgangskode',
      email: 'Email',
      submit: 'Send',
      sendEmail: 'Send os emailadressen du brugte til at registrere dig på Recright.',
      instructions: 'Vi sender dig instruktioner til, hvordan du ændrer din adgangskode.',
      success: 'Hvis bruger blev fundet med den angivne e-mailadresse, er instruktionen til ændring af din adgangskode blevet sendt til den adresse.',
    },

    changePassword: {
      title: 'Indstilling af adgangskode',
      name: 'Navn',
      email: 'Email',
      password: ' Ny adgangskode',
      confirmPassword: 'Gentag ny adgangskode',
      submit: 'Change password',
      error: {
        password: {
          isRequired: 'Adgangskode er påkrævet. ',
          isValidPassword: 'En gyldig adgangskode skal være på mindst 12 tegn og omfatte mindst et stort bogstav, et lille bogstav og et tal.',
          passwordsMatch: 'Adgangskoderne passer ikke sammen.',
        },
      },
    },

    ssoLogin: {
      title: 'SSO-login',
      description: 'Log ind med din organisations loginoplysninger.',
      info: 'Ekstern godkendelse ikke konfigureret. Brug venligst det',
      normalLoginLinkText: 'almindelige login.',
      submit: 'Log på tjenesten',
    },

    subscribe: {
      title: 'Abonnér',
      submit: 'Abonnér',
      creditCard: 'Betalingskort',
      cvv: 'CVV',
      expirationDate: 'Udløbsdato',
      vatAdvice: 'Hvis du giver os dit CVR-nummer, bliver der ikke lagt moms på din ordre.',
      vatId: 'Moms/skatte-nummer',
      vatHelp: 'Angiv dit moms-nummer i internationalt format inkl. landekode.',
      includeVat: 'Inkl. moms',
      firstName: 'Fornavn',
      lastName: 'Efternavn',
      email: 'E-mail',
      company: 'Virksomhed',
      street: 'Gade',
      postalCode: 'Postnummer',
      city: 'By',
      country: 'Land',
      emptyCardFields: 'Angiv dine betalingskortoplysninger',
      invalidValue: 'Feltværdi er ugyldig',
      planNotSelected: 'Angiv plan',
      totalPrice: 'Total',
      subscribed: 'Fantastisk! Dit abonnement er oprettet.',
      subscriptionExists: 'Det ser ud til, at din virksomhed har et aktivt abonnement. Log ind for at ændre dit abonnement.',
      agreeTos: 'Jeg har læst, og jeg godkender ',
      agreeTosLinkText: 'Brugervilkårene og betingelserne for Recright.',
      privacyPolicy: 'Vi værdsætter dit privatliv, læs venligst vores ',
      privacyPolicyLinkText: 'Privatlivspolitik.',
      licenseAgreement: 'På vegne af den organisation, jeg repræsenterer, accepterer jeg ',
      licenseAgreementLinkText: 'Recrights generelle tjenestevilkår.',
      newsletter: 'Tilmeld dig månedligt nyhedsbrev.',
      neverExpiresDiscount: amount => `Inkl. livstidsrabat ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Inkl. rabat ${amount} EUR for ${cycles} måneder`,
      errorFromProcessor: error => `Betalingshåndtering svarede med fejl: ${error}`,
    },

    videos: {
      title: 'Videobibliotek',
      add: 'Opret ny video',
      rename: 'Omdøb',
      remove: 'Fjern',
      yourVideos: 'Dine videoer',
      companyVideos: 'Virksomhedens videoer',
      sort: {
        createdAt: 'Oprettelsesdato',
        title: 'Titel',
      },

    },

    userManagement: {
      excel: 'Eksporter alle brugere',
      title: 'Brugeradministration',
      showCompanyDefaultPermissions: 'Vis standardtilladelser for virksomhed',
      activateUserConfirm: 'Er du sikker på, at du vil aktivere denne bruger?',
      deactivateUserConfirm: 'Er du sikker på, at du vil deaktivere denne bruger?',
      showActivatedUsers: 'Vis aktive brugere',
      showDeactivatedUsers: 'Vis deaktiverede brugere',
      confirmCancelEditPermissions: {
        message: 'Du har ikke-gemte ændringer. Er du sikker på, at du vil kassere alle ændringer?',
        cancel: 'Annullér',
        confirm: 'Kassér ændringer',
      },
      unsavedChanges: 'Du har ikke-gemte ændringer. Vil du gemme disse ændringer?',
      confirm: 'Gem',
      permissionsChangesSaved: 'Brugertilladelserne blev ændret!',
      userDeactivated: nameOrEmail => `${nameOrEmail} deaktiveret`,
      userActivated: nameOrEmail => `${nameOrEmail} aktiveret`,
      companyDefaultsSaved: 'Standardtilladelser for administrator blev ændret!',
      usersAddAdded: success => `${success} brugere blev tilføjet.`,
      usersAddExist: exist => ` ${exist} brugere er allerede oprettet i Recright.`,
      excel: 'Eksporter alle brugere',
    },

  },

}
